// The New count on the Platform → Enquiries sidebar item (website plan §6.4).
//
// A plain effect, not useQuery: the admin shell also renders without a
// QueryClientProvider (plan-locks.test.tsx), as UsageBanner does. Read again
// when the page changes — so the count catches up after enquiries are
// followed up — and otherwise every 5 minutes.

import { useEffect, useState } from 'react';
import { enquiriesService } from '@/services/enquiries.service';

const REFRESH_MS = 5 * 60 * 1000;

export function useNewEnquiryCount(enabled: boolean, path: string): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let active = true;
    const load = () => {
      enquiriesService
        .summary()
        .then((summary) => {
          if (active) setCount(summary.by_status.NEW);
        })
        .catch(() => {
          // No badge is better than a broken one; the next refresh tries again.
        });
    };
    load();
    const id = window.setInterval(load, REFRESH_MS);
    return () => {
      active = false;
      window.clearInterval(id);
    };
  }, [enabled, path]);

  return count;
}
